﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPostRepeat", [
    "$rootScope",
    function ($rootScope) {
      return {
        link: function ($scope, $element, $attrs) {
          if ($scope.$last) {
            $rootScope.$broadcast("ng-repeat-finished", $attrs.repeatId);
          }
        },
      };
    },
  ]);
})(window.angular);
